let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1JHhH")).then(() => parcelRequire('fG14L'));